import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'

import { Overview } from '../../overview.model'

@Component({
  selector: 'ratings',
  templateUrl: './ratings.component.html',
  styleUrls: ['./ratings.component.scss'],
  providers: [],
})
export class RatingsComponent implements OnInit, OnDestroy {
  @Input()
  overviewModel: Overview

  riskRatings: AEMChunk
  riskScale: AEMChunk
  riskScaleOne: AEMChunk
  riskScaleTwo: AEMChunk
  riskScaleThree: AEMChunk
  riskScaleFour: AEMChunk
  riskScaleFive: AEMChunk
  aemContentSub: Subscription

  riskCodeCollection: any[] = [
    {
      index: {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        riskCode: 1,
      },
    },
    {
      index: {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        riskCode: 2,
      },
    },
    {
      index: {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        riskCode: 3,
      },
    },
    {
      index: {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        riskCode: 4,
      },
    },
    {
      index: {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        riskCode: 5,
      },
    },
  ]

  constructor(private readonly centralContentService: CentralContentService) {}

  ngOnInit(): void {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.riskRatings = this.centralContentService.getContentByBody(
          'fund_definitions_risk_ratings',
          content,
        )
        this.riskScale = this.centralContentService.getContentByBody(
          'fund_definitions_risk_scale',
          content,
        )
        this.riskScaleOne = this.centralContentService.getContentByBody(
          'fund_definitions_risk_scale_1',
          content,
        )
        this.riskScaleTwo = this.centralContentService.getContentByBody(
          'fund_definitions_risk_scale_2',
          content,
        )
        this.riskScaleThree = this.centralContentService.getContentByBody(
          'fund_definitions_risk_scale_3',
          content,
        )
        this.riskScaleFour = this.centralContentService.getContentByBody(
          'fund_definitions_risk_scale_4',
          content,
        )
        this.riskScaleFive = this.centralContentService.getContentByBody(
          'fund_definitions_risk_scale_5',
          content,
        )
      },
    )
  }

  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
